import { render, staticRenderFns } from "./PurchaseDuoStadagenPerBuSorted.vue?vue&type=template&id=b06bd744&"
import script from "./PurchaseDuoStadagenPerBuSorted.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoStadagenPerBuSorted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports